<template>
    <!-- 详情头部菜单和大图标题公用组件 -->
    <div>
        <!-- 顶部大图加导航 -->
        <div class="top">
            <!-- 顶部logo大导航组件 -->
            <div class="about_top_logo">
                <topMenu></topMenu>
            </div>
            <div class="about_top" :style="{'background-image':'url('+topBgImg+')','background-repeat':'no-repeat'}">
                <div class="containers">
                    <!-- 中部大标题——公司简介 -->
                    <div class="about_top_bigtitle">
                        <h1>{{bigTitle.enTitle}}</h1>
                        <h2>{{bigTitle.znTitle}}</h2>
                    </div>
                </div>
            </div>
        </div>

        <!-- 头部底部面包屑导航 -->
        <nav class="breadcrumb">
            <ul class="breadcrumb_cont">
                <li class="li home">
                    <router-link to="/home">
                        <!-- <a href="../..//index.html#/home"> -->
                        <img src="../../assets/imgs/componentsPic/icon_home.png" />
                        <!-- </a> -->
                    </router-link>
                </li>
                <li class="li sort1 hoverClass" ref="meunLi" @mouseover="mouseOverOne" @mouseleave="mouseLeaveOne">
                    <a>{{menuLi.sortOne.title}}
                        <i class="el-icon-arrow-down"></i>
                    </a>
                    <div>
                        <router-link v-for="(item,i) in menuLi.sortOne.children" :key="i" :to="{path:item.url}" :class="item.active?'active':''">{{item.name}}
                        </router-link>
                    </div>
                </li>


                <li class="li hoverClass" ref="meunLiChildren" @mouseover="mouseOverTwo" @mouseleave="mouseLeaveTwo" :style="{width:(menuLi.sortTwo.title.length>6?'14.76vw':'12.76vw')}">
                    <!-- <router-link :to="{path:menuLi.sortTwo.url}">{{menuLi.sortTwo.title}}</router-link> -->

                    <a>{{menuLi.sortTwo.title}}
                        <i class="el-icon-arrow-down"></i>
                    </a>
                    <div v-if="menuLi.sortOne.title==='职等你来'">
                        <router-link v-for="(item,i) in menuLi.sortTwo.children" :key="i" :to="{path:item.url}" :class="item.active?'active':''" @click.native="refresh">{{item.name}}
                        </router-link>
                    </div>
                    <div v-else>
                        <router-link v-for="(item,i) in menuLi.sortTwo.children" :key="i" :to="{path:item.url}" :class="item.active?'active':''">{{item.name}}
                        </router-link>
                    </div>

                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    import topMenu from "@/components/global/topMenu.vue";
    export default {
        props: {
            topBgImg: {
                type: String,
                default: ""
            },
            bigTitle: {
                type: Object,
                default: {}
            },
            menuLi: {
                type: Object,
                default: {}
            }
        },
        methods: {
            refresh() {
                this.$router.go(0);
            },
            //鼠标移入事件。操作一级菜单展示它下面所有的子菜单
            mouseOverOne(e) {
                // 根据html结构，当一级菜单li存在子菜单div时
                if (this.$refs.meunLi.children[1]) {
                    // 计算出子菜单个数
                    var h = this.$refs.meunLi.children[1].children.length;
                    // 根据每个子菜单高度，计算出展示的下拉高度
                    this.$refs.meunLi.children[1].style.height = h * 2.60417 + "vw";
                    //给自身移入时添加激活样式on
                    e.currentTarget.className = "li hoverClass sort1 on";
                    //自身li种a标签文字字体颜色更改为#666
                    e.currentTarget.children[0].style =
                        "color:#666;border-bottom:1px solid #EDEFEE";
                    //当自身一级菜单激活时，所有div种的二级菜单文字字体颜色更改为#666
                    for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
                        e.currentTarget.children[1].children[i].style = "color:#666";
                    }
                }
            },
            // 鼠标移除事件，操作一级菜单隐藏下面所有子菜单
            mouseLeaveOne(e) {
                //过程与鼠标移入相反
                if (this.$refs.meunLi.children[1]) {
                    this.$refs.meunLi.children[1].style.height = "0";
                    e.currentTarget.className = "li hoverClass sort1";
                    e.currentTarget.children[0].style = "color:#d0d0d0";
                    for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
                        e.currentTarget.children[1].children[i].style = "color:#d0d0d0";
                    }
                }
            },

            //二级子菜单
            mouseOverTwo(e) {
                // 根据html结构，当一级菜单li存在子菜单div时
                if (this.$refs.meunLiChildren.children[1]) {
                    // 计算出子菜单个数
                    var h = this.$refs.meunLiChildren.children[1].children.length;
                    // 根据每个子菜单高度，计算出展示的下拉高度
                    this.$refs.meunLiChildren.children[1].style.height = h * 2.60417 + "vw";
                    //给自身移入时添加激活样式on
                    e.currentTarget.className = "li sort1 hoverClass on";
                    //自身li种a标签文字字体颜色更改为#666
                    e.currentTarget.children[0].style =
                        "color:#666;border-bottom:1px solid #EDEFEE";
                    //当自身一级菜单激活时，所有div种的二级菜单文字字体颜色更改为#666
                    for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
                        e.currentTarget.children[1].children[i].style = "color:#666";
                    }
                }
            },
            // 鼠标移除事件，操作一级菜单隐藏下面所有子菜单
            mouseLeaveTwo(e) {
                //过程与鼠标移入相反
                if (this.$refs.meunLiChildren.children[1]) {
                    this.$refs.meunLiChildren.children[1].style.height = "0";
                    e.currentTarget.className = "li sort1 hoverClass";
                    e.currentTarget.children[0].style = "color:#d0d0d0";
                    for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
                        e.currentTarget.children[1].children[i].style = "color:#d0d0d0";
                    }
                }
            },



            // downGb(e) { //点击本页导航
            //     // 过程与鼠标移入相反
            //     if (this.$refs.meunLi.children[1]) {
            //         this.$refs.meunLi.children[1].style.height = "0";
            //         e.currentTarget.className = "li sort1";
            //         e.currentTarget.children[0].style = "color:#d0d0d0";
            //         for (var i = 0; i < e.currentTarget.children[1].children.length; i++) {
            //             e.currentTarget.children[1].children[i].style = "color:#d0d0d0";
            //         }
            //     }
            // }
        },
        components: {
            topMenu,
        }
    };
</script>

<style scoped>
</style>